import React from "react";

import "./BreakdownRecipients.scss";

export interface IBreakdownRecipient {
  name: string;
  count?: number;
}

export interface IBreakdownRecipientsProps {
  label: string;
  items: IBreakdownRecipient[];
}

const BreakdownRecipients: React.FC<
  React.PropsWithChildren<IBreakdownRecipientsProps>
> = (props) => (
  <div className="c-breakdown-recipients">
    <div className="c-breakdown-recipients__label">{props.label}</div>
    <ul className="c-breakdown-recipients__list">
      {props.items.map((item, index) => (
        <li key={`${item.name}${index}`}>
          {item.name}
          {item.count && <span>&nbsp;({item.count})</span>}
        </li>
      ))}
    </ul>
  </div>
);

export default BreakdownRecipients;
